<app-header></app-header>
<app-toolbar></app-toolbar>
<app-submenu [items]="subMenuItems" [backBgGray]="true"></app-submenu>
<main class="min-h-screen flex justify-center items-start bg-[#f6f6f6] pt-10 pb-20 min-w-[1010px]">
  <!---------------------------------------------MODAL CLIENTE------------------------------------------------>
  <p-dialog [modal]="true" [(visible)]="formSteps['customerDataForm']" [style]="{width: '35vw'}"
    header="Titular de la factura">
    <form [formGroup]="formCustomer" (ngSubmit)="saveCustomer()">
      <div class="flex flex-col  justify-center">
        <p-autoComplete [tabindex]="1" #searcherAutocomplete [suggestions]="results" [showClear]="true"
          [virtualScrollItemSize]="50" (completeMethod)="searchCustomer($event)" (onSelect)="onSelectCustomer($event)"
          styleClass="w-full" field="name" value="name"
          inputStyleClass="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 w-full px-2 mb-2 "
          placeholder="Buscar cliente">
          <ng-template let-item pTemplate="itemTemplate">
            <div class="autocomplete-item">
              <h3>{{item.name}}</h3>
              <span class="text-xs text-gray-700">{{item.email}}</span>
            </div>
          </ng-template>
        </p-autoComplete>
        <div class="mb-2">
          <label for="name" class="text-[#27368A] font-bold text-base">
            Nombre completo:
          </label>
          <input
            [ngClass]="{'border-red-600' : formCustomer.get('name')?.touched && formCustomer.get('name')?.hasError('required')}"
            formControlName="name" type="text" placeholder="Nuevo Cliente" tabindex="2"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
          <div *ngIf="formCustomer.controls['name'].touched">
            <p *ngIf="formCustomer.get('name')?.hasError('required')" class="text-red-600 text-xs font-bold">
              Campo obligatorio
            </p>
          </div>
        </div>
        <div class="mb-2">
          <label for="cif" class="text-[#27368A] font-bold text-base">
            Documento Identificación:
          </label>
          <input
            [ngClass]="{'border-red-600' : formCustomer.get('cif')?.touched && formCustomer.get('cif')?.hasError('required')}"
            formControlName="cif" type="text" placeholder="DNI/CIF/NIE"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full" tabindex="3">
          <div *ngIf="formCustomer.controls['cif'].touched">
            <p *ngIf="formCustomer.get('cif')?.hasError('required')" class="text-red-600 text-xs font-bold">
              Campo obligatorio
            </p>
          </div>
        </div>
        <div class="mb-2">
          <label for="phone" class="text-[#27368A] font-bold text-base">
            Teléfono:
          </label>
          <input
            [ngClass]="{'border-red-600' : formCustomer.get('phone')?.touched && formCustomer.get('phone')?.hasError('required')}"
            formControlName="phone" type="text" placeholder="teléfono"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full" tabindex="4">
          <div *ngIf="formCustomer.controls['phone'].touched">
            <p *ngIf="formCustomer.get('phone')?.hasError('required')" class="text-red-600 text-xs font-bold">
              Campo obligatorio
            </p>
          </div>
        </div>
        <div class="mb-2">
          <label for="email" class="text-[#27368A] font-bold text-base">
            Email:
          </label>
          <input
            [ngClass]="{'border-red-600' : formCustomer.get('email')?.touched && formCustomer.get('email')?.hasError('required')}"
            formControlName="email" type="email" placeholder="email"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full" tabindex="5">
          <div *ngIf="formCustomer.controls['email'].touched">
            <p *ngIf="formCustomer.get('email')?.hasError('required')" class="text-red-600 text-xs font-bold">
              Campo obligatorio
            </p>
            <p *ngIf="formCustomer.get('email')?.hasError('email')" class="text-red-600 text-xs font-bold">
              Formato no
              válido
            </p>
          </div>
        </div>
        <div class="flex flex-row justify-end">
          <button type="submit" [disabled]="!formCustomer.valid "
            class="text-white font-bold text-base flex place-content-center justify-center disabled:opacity-65 align-middle items-center bg-black rounded-lg mt-2 h-8 w-40 px-6 enabled:hover:bg-[#27368A]">
            Guardar
          </button>
        </div>
      </div>
    </form>
  </p-dialog>
  <!---------------------------------------------MODAL DIRECCIÓN------------------------------------------------>
  <p-dialog [modal]="true" [(visible)]="formSteps['addressCustomerForm']" [style]="{width: '50%'}"
    [breakpoints]="{ '1900px': '75%' }" header="Dirección del titular">
    <form [formGroup]="formAddressCustomer" (ngSubmit)="saveAddressCustomer()">
      <ng-template pTemplate="header">
        <h4 class="text-[#27368A] font-extrabold text-xl flex place-items-center">Dirección</h4>
      </ng-template>
      <div class="grid grid-cols-2 gap-10 justify-center">
        <div class=" flex flex-col">
          <div class="mb-2">
            <label for="street_name" class="text-[#27368A] font-bold text-base">
              Nombre de la calle:
            </label>
            <input
              [ngClass]="{'border-red-600' : formAddressCustomer.get('street_name')?.touched && formAddressCustomer.get('street_name')?.hasError('required')}"
              tabindex="1" formControlName="street_name" type="text" placeholder="Nombre de la calle"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formAddressCustomer.controls['street_name'].touched">
              <p *ngIf="formAddressCustomer.get('street_name')?.hasError('required')"
                class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="street_number" class="text-[#27368A] font-bold text-base">
              Número:
            </label>
            <input
              [ngClass]="{'border-red-600' : formAddressCustomer.get('street_number')?.touched && formAddressCustomer.get('street_number')?.hasError('required')}"
              tabindex="2" formControlName="street_number" type="text" placeholder="Numero de la calle"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formAddressCustomer.controls['street_number'].touched">
              <p *ngIf="formAddressCustomer.get('street_number')?.hasError('required')"
                class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <label for="floor" class="text-[#27368A] font-bold text-base">
            Piso:
          </label>
          <input formControlName="floor" type="text" placeholder="piso" tabindex="3"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full mb-2 ">
          <label for="description" class="text-[#27368A] font-bold text-base">
            Letra/Descripción:
          </label>
          <input formControlName="description" tabindex="4" type="text" placeholder="Letra/Descripción"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
        </div>
        <div class="flex flex-col">
          <div class="mb-2">
            <label for="city" class="text-[#27368A] font-bold text-base">
              Ciudad:
            </label>
            <input
              [ngClass]="{'border-red-600' : formAddressCustomer.get('city')?.touched && formAddressCustomer.get('city')?.hasError('required')}"
              tabindex="5" formControlName="city" type="text" placeholder="Ciudad"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formAddressCustomer.controls['city'].touched">
              <p *ngIf="formAddressCustomer.get('city')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <label for="province" class="text-[#27368A] font-bold text-base">
            Provincia:
          </label>
          <input formControlName="province" tabindex="6" type="text" placeholder="Provincia"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full mb-2 ">
          <div class="mb-2">
            <label for="country" class="text-[#27368A] font-bold text-base">
              País:
            </label>
            <input
              [ngClass]="{'border-red-600' : formAddressCustomer.get('country')?.touched && formAddressCustomer.get('country')?.hasError('required')}"
              tabindex="7" formControlName="country" type="text" placeholder="País"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formAddressCustomer.controls['country'].touched">
              <p *ngIf="formAddressCustomer.get('country')?.hasError('required')"
                class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="postal_code" class="text-[#27368A] font-bold text-base">
              Código postal:
            </label>
            <input
              [ngClass]="{'border-red-600' : formAddressCustomer.get('postal_code')?.touched && formAddressCustomer.get('postal_code')?.hasError('required')}"
              tabindex="8" formControlName="postal_code" type="text" placeholder="Código postal"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formAddressCustomer.controls['postal_code'].touched">
              <p *ngIf="formAddressCustomer.get('postal_code')?.hasError('required')"
                class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
              <p *ngIf="formAddressCustomer.get('postal_code')?.hasError('pattern')"
                class="text-red-600 text-xs font-bold">
                Mínimo de 5 caracteres (letras y/o números)
              </p>
            </div>
          </div>
          <div class="flex justify-end  mt-4">
            <div *ngIf="warningMessage" class="text-red-600 text-xs font-bold flex align-middle items-center">
              {{ warningMessage }}
            </div>
            <button type="submit" [ngClass]="{'bg-gray-500 hover:bg-gray-500': !formAddressCustomer.valid}"
              [disabled]="!formAddressCustomer.valid"
              class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-9 w-32 px-6 ml-4 hover:bg-[#27368A]">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </form>
  </p-dialog>
  <!---------------------------------------------MODAL TRANSACCIONES------------------------------------------------>
  <p-dialog [modal]="true" [(visible)]="transactionModalVisible" [style]="{width: '50vw'}" header="Crear Transacciones">
    <form (ngSubmit)="saveTransactions()">
      <div class="flex flex-col justify-center">
        <table class="w-full border-collapse border border-gray-200 my-2 text-left">
          <thead class="bg-gray-200">
            <tr>
              <th class="border border-gray-300 px-4 py-1">Método de pago</th>
              <th class="border border-gray-300 px-4 py-1">Monto</th>
              <th class="border border-gray-300 px-4 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let transactionForm of transactionForms; let i = index" [formGroup]="transactionForm">
              <td class="border border-gray-300 px-4 py-1">
                <select formControlName="payment_method"
                  class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
                  <option value="EFECTIVO">Efectivo</option>
                  <option value="TARJETA">Tarjeta</option>
                  <option value="BIZUM">Bizum</option>
                  <option value="TRANSFERENCIA">Transferencia</option>
                </select>
              </td>
              <td class="border border-gray-300 px-4 py-1">
                <input formControlName="amount" type="text" placeholder="Monto"
                  class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
                <div *ngIf="transactionForm.controls['amount'].touched">
                  <p *ngIf="transactionForm.get('amount')?.hasError('required')" class="text-red-600 text-xs font-bold">
                    Campo obligatorio</p>
                  <p *ngIf="transactionForm.get('amount')?.hasError('pattern')" class="text-red-600 text-xs font-bold">
                    Formato no válido</p>
                </div>
              </td>
              <td class="border border-gray-300 px-4 py-1 text-center">
                <button type="button" (click)="removeTransactionForm(i)" [disabled]="transactionForms.length <= 1"
                  class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-red-500 rounded-lg h-8 w-8 px-2 hover:bg-red-700 disabled:opacity-65">-</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="flex justify-end mb-2">
          <button type="button" (click)="addTransactionForm()"
            class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-green-500 rounded-lg h-8 w-8 px-2 hover:bg-green-700">+</button>
        </div>
        <div class="flex flex-row justify-end">
          <p class="text-red-600 text-xs font-bold mr-4" *ngIf="getTotalTransactionAmount() !== invoice.total">El monto
            total de las transacciones debe ser igual al monto total de la factura ({{invoice.total}}€).</p>
          <button type="submit" [disabled]="getTotalTransactionAmount() !== invoice.total"
            class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-8 w-40 px-6 hover:bg-[#27368A]">Guardar</button>
        </div>
      </div>
    </form>
  </p-dialog>
  <section
    class="bg-white rounded-[15px] border border-[#f0f0f0] mx-auto p-10 pb-20 shadow-[1px_1px_20px_0px_rgba(0,0,0,0.1)] w-[1000px] min-h-[700px] relative">
    <ng-container *ngIf="invoice ; else noAuthorizationPdf">
      <article class="flex justify-between">
        <figure>
          <img src="./assets/img/logo_cangas_aventura.png" class="w-[220px]" alt="">
        </figure>
        <div>
          <h3 style="color: red" class="text-[30px] font-bold">Factura</h3>
          <p class="font-bold text-[15px]">Num: {{ invoiceNumber }}</p>
        </div>
      </article>
      <article class="mt-10 flex">
        <div class="m-2 p-1 border border-black grow basis-0 flex">
          <table>
            <tr>
              <td class="font-bold block text-nowrap">Razón social:&nbsp;</td>
              <td class="font-normal pl-2">{{ invoice.company_name }}</td>
            </tr>
            <tr>
              <td class="font-bold block text-nowrap">CIF:&nbsp;</td>
              <td class="font-normal pl-2">{{ invoice.company_cif }}</td>
            </tr>
            <tr>
              <td class="font-bold block text-nowrap">Dirección fiscal:&nbsp;</td>
              <td class="font-normal pl-2">{{ invoice.company_address }}</td>
            </tr>
            <tr>
              <td class="font-bold block text-nowrap">Correo:&nbsp;</td>
              <td class="font-normal pl-2">{{ invoice.company_email }}</td>
            </tr>
          </table>
        </div>
        <div class="m-2 p-1 border border-black grow basis-0 relative">
          <div class="absolute top-[5px] right-[5px]">
            <button (click)="toggleForm('customerDataForm')"
              class="text-white font-bold text-base flex justify-center align-middle items-center bg-black rounded-lg h-6 w-6 p-1 hover:bg-[#27368A]">
              +
            </button>
          </div>
          <table class="w-full">
            <tr>
              <td class="font-bold block text-nowrap">Cliente:&nbsp;</td>
              <td class="font-normal pl-2 pr-4">
                <div class="w-full pr-4">
                  {{ invoice?.customer_name }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="font-bold block text-nowrap">CIF:&nbsp;</td>
              <td class="font-normal pl-2">{{ invoice?.customer_cif }}</td>
            </tr>
            <tr>
              <td class="font-bold block text-nowrap">Tel:&nbsp;</td>
              <td class="font-normal pl-2">{{ invoice?.customer_phone }}</td>
            </tr>
            <tr>
              <td class="font-bold block text-nowrap">Correo:&nbsp;</td>
              <td class="font-normal pl-2">{{ invoice?.customer_email }}</td>
            </tr>
            <tr>
              <td class="font-bold block text-nowrap">Dirección fiscal:&nbsp;</td>
              <td class="font-normal pl-2 ">
                <div>
                  <div class="text-right" *ngIf="selectedCustomer && !selectedCustomer?.address">
                    <button (click)="toggleForm('addressCustomerForm')"
                      class="text-white font-bold text-base flex ml-auto justify-center align-middle items-center bg-black rounded-lg h-6 w-6 p-1 hover:bg-[#27368A]">
                      +
                    </button>
                  </div>
                  <ng-container *ngIf="selectedCustomer?.address">
                    <div class="grid grid-cols-8">
                      <div class="col-span-7 flex flex-wrap">
                        <p class="text-[#8A8A8A] font-bold text-base mr-1">
                          {{selectedCustomer?.address?.alias }}:
                        </p>
                        <p class="text-[#8A8A8A] text-base text-clip">
                          {{selectedCustomer?.address?.street_name}}
                          {{ selectedCustomer?.address?.street_number }}
                          {{ selectedCustomer?.address?.floor }}
                          {{ selectedCustomer?.address?.description }}
                          {{ selectedCustomer?.address?.city }}-
                          {{ selectedCustomer?.address?.province }}
                          {{ selectedCustomer?.address?.country }}
                          {{ selectedCustomer?.address?.postal_code }}
                        </p>
                      </div>
                      <div class="col-span-1 flex flex-row  gap-2">
                        <button (click)="editAddress(selectedCustomer?.address)" pInputText>
                          <i class="pi pi-pencil" style="font-size: 0.2rem" style="color: #27368A"></i>
                        </button>
                        <button (click)="deleteAddress(selectedCustomer?.address)" pInputText>
                          <i class="pi pi-times" style="font-size: 0.2rem" style="color: red"></i>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </td>
              <!-- <td class="font-normal pl-2">{{ invoice?.customer_address }}</td> -->
            </tr>
          </table>
        </div>
      </article>
      <article class="mt-10 flex justify-between">
        <p><span class="font-bold">Fecha:&nbsp;</span>{{ time }}</p>
        <p><span class="font-bold">Referencia de factura:&nbsp;</span>{{ invoice.reference }}</p>
        <p><span class="font-bold">Estado:&nbsp;</span>{{ statusText }}</p>
      </article>
      <article class="mt-10">
        <table class="w-full ">
          <thead class="bg-[lightgray]">
            <tr>
              <th class="text-nowrap border border-white">Concepto</th>
              <th class="text-nowrap border border-white">Unidades</th>
              <th class="text-nowrap border border-white">Precio</th>
              <th class="text-nowrap border border-white">% Dto.</th>
              <th class="text-nowrap border border-white">Importe</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="invoiceDetails && invoiceDetails.length > 0; else noDataOnTable">

              <tr *ngFor="let detail of invoiceDetails">
                <td>
                  <input class="text-left w-full" type="text" (keyup)="handleInputData($event, 'concept', detail.id)"
                    [value]="detail.concept">
                </td>
                <td class="text-right">
                  <input class="text-right" type="text" (keyup)="handleInputData($event, 'units', detail.id)"
                    (blur)="setInputToZero($event, 'units', detail.id)" [value]="detail.units">
                </td>
                <td class="text-right">
                  <input class="text-right" type="text" (keyup)="validateOnlyFloat($event)"
                    (blur)="handleInputData($event, 'unit_price', detail.id)" [value]="detail.unit_price ?? '0.00'">€
                </td>
                <td class="text-right">
                  <div class="flex flex-nowrap">
                    <input class="text-right" type="text" (keyup)="handleInputData($event, 'vat', detail.id)"
                      (blur)="setInputToZero($event, 'vat', detail.id)" [value]="detail.vat">%
                  </div>
                </td>
                <td class="text-right">{{ detail.detail_subtotal.toFixed(2) }}€</td>
              </tr>
            </ng-container>
            <ng-template #noDataOnTable>
              <tr>
                <td colspan="5" class="text-center">
                  No existen detalles para este ticket
                </td>
              </tr>
            </ng-template>
          </tbody>
          <tfoot>
            <ng-container *ngIf="invoiceDetails && invoiceDetails.length > 0">
              <tr>
                <td colspan="3"></td>
                <td class="font-bold text-right">Base imponible en €</td>
                <td class="font-bold text-right">{{ totals['totalBase'].toFixed(2) }}€</td>
              </tr>
              <tr>
                <td colspan="3"></td>
                <td class="font-bold text-right">{{ invoice.tax_name }} total en €</td>
                <td class="font-bold text-right">{{ totals['totalTaxes'].toFixed(2) }}€</td>
              </tr>
              <tr>
                <td colspan="3"></td>
                <td class="font-bold text-right">TOTAL en €</td>
                <td class="font-bold bg-[lightgray] text-right">{{ totals['totalEur'].toFixed(2) }}€</td>
              </tr>
            </ng-container>
          </tfoot>
        </table>
        <div class="text-right flex">
          <button
            class="rounded-[15px] bg-green-500 text-white text-[20px] font-[600] rounded-[12px] px-[18px] py-[5px] flex gap-2 items-center mb-3 ml-auto mt-7"
            routerLink="/panel/payments/invoices/create">Crear Nueva</button>
          <button
            class="rounded-[15px] bg-[#429DCF] text-white text-[20px] font-[600] rounded-[12px] px-[18px] py-[5px] flex gap-2 items-center mb-3 ml-2 mt-7"
            (click)="updateInvoice()"
            [disabled]="!selectedCustomer || !selectedCustomer?.address || isButtonSaveInvoiceDisabled">Guardar</button>
        </div>
      </article>
      <footer class="px-7 py-2 bg-gray-200 text-center absolute bottom-[25px] left-[25px] w-[940px]">
        "Nuestra experiencia y una atención personalizada son nuestra garantía"
      </footer>
    </ng-container>

    <ng-template #noAuthorizationPdf>
      <h3 class="text-red-500 text-center">NO SE PUEDE EDITAR ESTA FACTURA</h3>
    </ng-template>
  </section>
</main>
<p-toast></p-toast>